import type { CountryCode, GatewayManifestEntry } from './types';

/**
 * The single source of truth for "which gateways exist and where do they
 * run." Adding a gateway means adding one entry here plus one adapter
 * folder — nothing else in the app changes. See the plan's runbook (§7).
 *
 * `load` is the code-splitting boundary: React.lazy() (via GatewayFactory)
 * only pulls a gateway's JS in once it's actually selected for the current
 * country, so India never downloads 2C2P's code and vice versa.
 */
export const GATEWAY_MANIFEST: GatewayManifestEntry[] = [
  {
    id: 'razorpay',
    countries: ['IN'],
    label: 'Razorpay',
    icon: 'razorpay',
    default: true,
    load: () =>
      import('../gateways/razorpay/RazorpayAdapter').then((m) => ({
        default: m.razorpayAdapter,
      })),
  },
  {
    id: '2c2p',
    countries: ['TH'],
    label: '2C2P',
    icon: '2c2p',
    default: true,
    load: () =>
      import('../gateways/2c2p/TwoC2PAdapter').then((m) => ({
        default: m.twoC2PAdapter,
      })),
  },
];

export function getGatewaysForCountry(
  country: CountryCode
): GatewayManifestEntry[] {
  return GATEWAY_MANIFEST.filter((entry) => entry.countries.includes(country));
}

export function getGatewayById(id: string): GatewayManifestEntry | undefined {
  return GATEWAY_MANIFEST.find((entry) => entry.id === id);
}
